import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'odin-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./loading-spinner.component.scss'],
})
export class LoadingSpinnerComponent {
  @Input() public active = false;
  @Input() public overlay = false;
  @Input() public diameter = 60;
  @Input() public strokeWidth = 5;
  @Input() public colour = 'primary';
  @Input() public showContent = false;
}
